import { OfferRequestComponent } from './der-tailormade-offer-request.component';

export * from './der-tailormade-offer-request.component';
export default OfferRequestComponent;

OfferRequestComponent.define('der-tailormade-offer-request');

declare global {
    interface HTMLElementTagNameMap {
        'der-tailormade-offer-request': OfferRequestComponent;
    }
}
